import { useSelector } from 'react-redux';
import { selectEntryById, selectChannelClientByIds } from 'app/store/groupsSlice';
import SidebarListItem from 'app/shared-components/layout/SidebarListItem';


function ClientSidebarListItem(props) {
  const { groupId, clientId, onClick, type, registerPath } = props;
  const client = useSelector(selectChannelClientByIds(groupId, clientId));
  const entry= useSelector(selectEntryById(client?.channelId));
  const unread= entry && entry.unread;

  return (
	  <SidebarListItem link={"/apps/" + type + "/" + groupId + "/client/" + clientId}
           			   key={clientId}
           			   icon="heroicons-outline:chat-bubble-bottom-center-text"
           			   text={client.firstName + " " + client.lastName}
           			   onClick={onClick}
                       registerPath={registerPath}
           			   unread={unread}/>
  );
}

export default ClientSidebarListItem;
